import { useState as commonUseState } from "packages/react";

export const useState = commonUseState;
